module.exports = __webpack_public_path__ + "static/australia-flag-square-xs@2x-516ceb9ade8708aecb46df1432620fb4.png";